import { UpsellModel } from './models';

export const state = {
  currentUpsell: new UpsellModel(),
  showUpsellModal: false,
};

export const mutations = {

};